module.exports = __webpack_public_path__ + "static/media/Дневное небо.a35d11de.png";